import { Icon } from "../components/Icon";
import { Upload01 } from "../icons/v2-stroke";
import { cn } from "../lib";
import anim from "../lottie/dragArea";
import Lottie from "lottie-react";
import React, { useEffect, useRef, useState } from "react";
/**
 * A full-surface visual overlay that signals a drop target during a
 * drag-and-drop file upload, toggled with isDragActive and labeled with title
 * and description. Use it to give clear feedback when a user drags files over
 * a region that accepts uploads; it only renders the cue and does not handle
 * the drop itself.
 * @summary Drag-and-drop upload overlay cue.
 */
export function DropzoneOverlay({ description, isDragActive, title, visual = React.createElement(Icon, { visual: Upload01, size: "lg", className: "text-background" }), }) {
    const lottieRef = useRef(null);
    const [isActiveDelayed, setIsActiveDelayed] = useState(false);
    // This is used to delay the removal of the overlay when the user stops dragging.
    useEffect(() => {
        if (isDragActive) {
            setIsActiveDelayed(true);
        }
        else {
            const timeoutId = setTimeout(() => {
                setIsActiveDelayed(false);
            }, 400);
            return () => clearTimeout(timeoutId);
        }
    }, [isDragActive]);
    if (!isActiveDelayed) {
        return null;
    }
    return (React.createElement("div", { className: cn("absolute inset-0 z-50 flex h-full w-full flex-col items-center justify-center gap-0", "bg-background/80", "text-foreground"), onMouseLeave: () => {
            var _a, _b, _c;
            (_a = lottieRef.current) === null || _a === void 0 ? void 0 : _a.setDirection(-1);
            (_b = lottieRef.current) === null || _b === void 0 ? void 0 : _b.setSpeed(2);
            (_c = lottieRef.current) === null || _c === void 0 ? void 0 : _c.play();
        }, onDrop: () => {
            var _a, _b;
            (_a = lottieRef.current) === null || _a === void 0 ? void 0 : _a.setDirection(-1);
            (_b = lottieRef.current) === null || _b === void 0 ? void 0 : _b.play();
        } },
        React.createElement("div", { className: "relative" },
            React.createElement(Lottie, { lottieRef: lottieRef, animationData: anim, style: { width: `200px`, height: `200px` }, loop: false, autoplay: true }),
            React.createElement("div", { className: "absolute", style: { top: `84px`, left: `84px` } }, visual)),
        React.createElement("div", { className: "heading-xl" }, title),
        React.createElement("div", { className: "text-base text-muted-foreground" }, description)));
}
//# sourceMappingURL=DropzoneOverlay.js.map